import pagesNames from "../../../constants/pages-names";

const governancePageData = {
    mainTitle : "الحوكمة",
    borderSection : {
        title : "الهدف العام",
        subtitle : "الالتزام بمستوى عالٍ من الحوكمة وتعزيز النزاهة والمسؤولية في جميع عمليات صنع القرار.",
    },
    paragraphOne : "يعمل الأول وفق أساس متين من الحوكمة التي تخلق القيمة، حيث نعتقد أن اتباع نهج قوي للحوكمة هو من العوامل المهمة لتحقيق الاستدامة لدينا. ولهذا، يتبنى البنك أعلى معايير الحوكمة الرشيدة، كما أن لدينا سجلاً حافلاً بالإنجازات الإيجابية بما في ذلك التنوع؛ حيث يضم مجلس إدارة البنك مزيجاً من الخبراء المحليين والدوليين من مجموعة واسعة من القطاعات.",
    paragraphTwo : "من حيث تحقيق التنوع بين الجنسين، يقع الأول في الربع الأعلى للمنظمات في المنطقة، حيث يضم فريق الإدارة التنفيذية لدينا حالياً 5 إناث، ويشكل الإناث ما نسبته 22% من إجمالي موظفي البنك. ويوفر البنك التدريب والتطوير المستمر لكل أعضاء مجلس الإدارة لضمان الالتزام بمعايير الحوكمة الرشيدة. ويشمل ذلك الدورات التدريبية الإلزامية الداخلية والخارجية الخاصة بمجموعة واسعة من الموضوعات، بما في ذلك الجرائم المالية، والتوعية بالأمن السيبراني، وبيئة الاقتصاد الكلي الإقليمية والعالمية. كما يغطي التدريب الاتجاهات الرئيسية في إدارة الامتثال ومخاطر مكافحة غسل الأموال، بالإضافة إلى التطورات في موضوعات الممارسات البيئية والاجتماعية والحوكمة المؤسسية، حيث يتلقى موظفو البنك تدريباً في هذا الجانب من خلال رواد داخليين مختارين يقومون بتيسير بناء الوعي حول الممارسات البيئية والاجتماعية والحوكمة المؤسسية في جميع وحدات العمل بالبنك.",
    paragraphThree : "تعد إدارة المخاطر جزءاً لا يتجزأ من خلق القيمة المستدامة. ويمتلك الأول ثقافة متطورة للمخاطر مدمجة في جميع وحدات الأعمال، ووظائف التمكين والتحكم. وخلال السنوات الأخيرة، قام البنك بتحسين إطار عمل إدارة المخاطر بحيث يتم الإبلاغ بشفافية عن المخاطر المرتبطة بالممارسات البيئية والاجتماعية والحوكمة المؤسسية.",
    sectionOne : {
        title : "محاور التركيز",
        cards : [
            {
                icon : "tree.svg",
                title : "نشر هيكل الحوكمة الخاص بالممارسات البيئية والاجتماعية والحوكمة المؤسسية",
                subtitle : "ضمان وجود هيكل يتناسب بالشكل الكافي مع أولويات الحوكمة لدى البنك",
            },
            {
                icon : "social-network.svg",
                title : "اعتماد الممارسات البيئية والاجتماعية والحوكمة المؤسسية على مستوى جميع وحدات العمل بالبنك",
                subtitle : "التدريب والرواد الداخليون للممارسات البيئية والاجتماعية والحوكمة المؤسسية",
            },
            {
                icon : "news.svg",
                title : "الانضمام للجهات الموقعة على المعايير الدولية",
                subtitle : "مبادئ الأمم المتحدة للخدمات المصرفية المسؤولة",
            },
            {
                icon : "bag.svg",
                title : "إطار الحوكمة لدى البنك",
                subtitle : "إدارة المخاطر والامتثال",
            },
        ]
    },
    sectionTwo : {
        title : "هيكل الحوكمة",
        tableOne : {
            title : "هيكل وتشكيل مجلس الإدارة",
            table : {
                headers : ["تشكيل مجلس الإدارة", "2020", "2021", "2022"],
                data : [
                    {
                        element : "نسبة مقاعد مجلس الإدارة التي تشغلها الإناث",
                        2020 : "%18",
                        2021 : "%9",
                        2022 : "%9",
                    },
                    {
                        element : "النسبة المئوية لمقاعد مجلس الإدارة التي يشغلها أعضاء مستقلون (بما يتماشى مع المتطلبات التنظيمية)",
                        2020 : "%36",
                        2021 : "%36",
                        2022 : "%36",
                    },
                    {
                        element : "أعضاء مجلس الإدارة التنفيذيون",
                        2020 : "%9",
                        2021 : "%9",
                        2022 : "%9",
                    },
                    {
                        element : "أعضاء مجلس الإدارة غير التنفيذيين",
                        2020 : "%54",
                        2021 : "%54",
                        2022 : "%54",
                    },
                    {
                        element : "عضوات مجلس الإدارة من الإناث",
                        2020 : "2",
                        2021 : "1",
                        2022 : "1",
                    },
                    {
                        element : "أعضاء مجلس الإدارة من الذكور",
                        2020 : "9",
                        2021 : "10",
                        2022 : "10",
                    },
                    {
                        element : "أعضاء مجلس الإدارة المستقلون",
                        2020 : "4",
                        2021 : "4",
                        2022 : "4",
                    },
                    {
                        element : "أعضاء مجلس الإدارة غير التنفيذيين",
                        2020 : "6",
                        2021 : "6",
                        2022 : "6",
                    },
                ]
            },
            paragraph : 'يعمل مجلس الإدارة على وضع استراتيجية البنك بهدف تحقيق قيمة مستدامة للمساهمين وتشجيع ثقافة الانفتاح والحوار. كما يعتمد المجلس رأس المال والخطط التشغيلية الرامية إلى تحقيق التوجه الاستراتيجي وفقاً لتوصيات الإدارة التنفيذية ("لجنة الإدارة التنفيذية"). ويضم المجلس 11 عضواً منهم 5 أعضاء مستقلون. ويعتبر بنك الأول هو أول شركة مدرجة في المملكة تقوم بتعيين سيدة في منصب رئيس مجلس الإدارة.'
        },
        tableTwo : {
            title : "لجان مجلس الإدارة واللجان الإدارية",
            paragraph : "قام مجلس إدارة بنك الأول بتكليف فريق الحوكمة بتقييم هيكل اللجان الإدارية للحوكمة في البنك. وبعد عملية إعادة التقييم التي أخذت بعين الاعتبار اللوائح وأفضل الممارسات، تم تقليص عدد اللجان الإدارية من 40 إلى 24 لجنة تركز على الآثار الاقتصادية والبيئية والاجتماعية. وقد ساعد ذلك في تبسيط عملية صنع القرار من خلال الحد من تداخل المسؤوليات والتكرار وتوضيح الأهداف. وقد تم وضع مؤشر أداء رئيسي خاص بالممارسات البيئية والاجتماعية والحوكمة المؤسسية لعضو من أعضاء اللجان الإدارية للحوكمة في بطاقات قياس الأداء الخاصة بهم.",
            table : {
                head : "مجلس الإدارة واللجان الفرعية المنبثقة عنه",
                headers : [],
                data : [
                    [
                        "اللجنة التنفيذية ",
                        "لجنة المراجعة",
                        "لجنة المخاطر",
                        "لجنة الترشيحات والمكافآت",
                        "اللجنة التقنية والرقمية"
                    ],
                    [
                        "أنشأ مجلس إدارة الأول اللجنة التنفيذية بهدف دعمه في إداء مسؤولياته ومراقبته للعمليات والأنشطة اليومية للبنك. وتعقد اللجنة التنفيذية 6 اجتماعات سنوياً على الأقل.",
                        "تم إنشاء لجنة المراجعة لدعم مجلس إدارة البنك في أداء المسؤوليات مثل مراقبة مهام إدارة المراجعة الداخلية، ومراجعة الضوابط الداخلية وأنظمة التقارير، والتوصية بتعيين المدققين الخارجيين وتحديد أتعابهم، بالإضافة إلى أي مهام أخرى يكلفها بها المجلس على النحو المنصوص عليه في القواعد واللوائح الصادرة عن الجهات الرقابية.",
                        "تتولى لجنة المخاطر مهمة الإشراف على إدارة المخاطر المؤسسية وحوكمة المخاطر وأنظمة الرقابة الداخلية. كما تقدم المشورة لمجلس الإدارة بشأن المخاطر الناشئة للبنك، ونطاق تقبل المخاطر، واستراتيجية المخاطر.",
                        "تتولى لجنة الترشيحات والمكافآت التوصية بالترشيحات لعضوية مجلس الإدارة بما يتماشى مع سياسة اختيار البنك لأعضاء مجلس الإدارة واللجان المنبثقة عنه. كما تقوم اللجنة سنوياً بمراجعة احتياجات المهارات والإمكانيات المطلوبة والملائمة لعضوية المجلس. وتقوم اللجنة أيضاً بتقييم شامل لفعالية أعضاء مجلس الإدارة ولجانه ومجلس الإدارة نفسه.",
                        "تتولى لجنة التقنيات والرقمنة مسؤولية معاونة مجلس الإدارة في الإشراف على تنفيذ الخطة الاستراتيجية للبنك والأهداف الاستراتيجية والمبادرات الرئيسية الخاصة بالتقنيات والرقمنة والتحول والابتكار. وقد تم إنشاء هذه اللجنة خلال العام 2023.",
                    ]
                ]
            }
        }
    },
    sectionThree : {
        title : "الإنجازات الخاصة بإعادة تنظيم الحوكمة خلال العام 2022",
        subtitle : "تم إجراء تقييم لمجلس الإدارة من قبل خبير استشاري، وشمل جزء من التقييم مراجعة سياسات مجلس الإدارة لمواءمتها مع المتطلبات التنظيمية وأفضل الممارسات في مجال الحوكمة. وفي هذا الإطار، تم إجراء تحليل للثغرات لتوثيق التغييرات المطلوبة للتوافق مع اللوائح المعمول بها وأفضل الممارسات. وشمل التقييم أيضا مراجعة لهيكل المعلومات وتقديمها إلى مجلس الإدارة. وقد تولت إدارة الحوكمة بالبنك عملية إعادة صياغة السياسات والاختصاصات، فضلاً عن تقليص عدد اللجان الإدارية.",
        image : {
            alt : "",
            name : "governence-section-one.jpg"
        }
    },
    sectionFour : { 
        title : "إطار الحوكمة الخاص بالممارسات البيئية والاجتماعية والحوكمة المؤسسية ",
        paragraph : "خلال الفترة المشمولة بالتقرير، قام البنك بتنفيذ إطار جديد للحوكمة، حيث بدأت إدارة الحوكمة بالتعاون مع الإدارة القانونية العمل على الاستجابة للوائح التي سيتم اعتمادها بما يتماشى مع الأحكام الجديدة لقانون الشركات ولوائحه الصادرة في العام 2022. كما قادت إدارة الحوكمة بمراجعة سياسات مجلس الإدارة وكذلك اختصاصات اللجان المنبثقة عنه، وانتهى ذلك إلى وضع إطار حوكمة مبسط من شأنه أن يدعم أهداف البنك فيما يتعلق بالممارسات البيئية والاجتماعية والحوكمة المؤسسية على نحو أكثر فاعلية مستقبلاً.",
        borderBox : {
            title : "اللجنة التوجيهية للممارسات البيئية والاجتماعية والحوكمة المؤسسية",
            subtitle : "قام البنك بإنشاء تتألف اللجنة التوجيهية للممارسات البيئية والاجتماعية والحوكمة المؤسسية والتي تتألف من ممثلين من مختلف مجالات العمل والوظائف. وتتولى اللجنة مسؤولية الإشراف على جميع المسائل والأهداف الاستراتيجية المتعلقة بالممارسات البيئية والاجتماعية والحوكمة المؤسسية، بما في ذلك مخاطر التغير المناخي، حيث تقوم بدور الحوكمة والإشراف والإدارة والتنسيق الشامل لجميع الالتزامات ضمن الاستراتيجية المعتمدة للممارسات البيئية والاجتماعية والحوكمة المؤسسية. وتستمد اللجنة صلاحيتها من اللجنة التنفيذية المنبثقة عن مجلس الإدارة وتقوم بالمسؤوليات الموكلة إليها في إطار مستوى تقبل المخاطر وإطار الحوكمة الخاص بالبنك. وقد عقدت اللجنة خلال العام 2022 اجتماعها الأول برئاسة العضو المنتدب للبنك السيد.توني كريبس.",
        },
        linedData : [
            <p>اللجنة التوجيهية للممارسات البيئية والاجتماعية والحوكمة المؤسسية</p>,
            <p>رئيس اللجنة: العضو المنتدب </p>,
            <p>أمين سر اللجنة: المستشار الأول للممارسات البيئية والاجتماعية والحوكمة المؤسسية</p>
        ],
        cardsOne : [
            {
                title : "أعضاء اللجنة",
                subtitle : "يتم تحديد أعضاء اللجنة من قبل العضو المنتدب بالتشاور مع الأمين العام لمجموعة الأول، وتضم حالياً:",
                list : [
                    "العضو المنتدب (رئيس اللجنة)",
                    "الرئيس التنفيذي للرقابة المالية",
                    "الرئيس التنفيذي للمخاطر",
                    "الرئيس التنفيذي للعمليات",
                    "الرئيس التنفيذي لمصرفية الشركات والمؤسسات",
                    "الرئيس التنفيذي لإدارة الثروات والمصرفية الشخصية ",
                    "الرئيس التنفيذي للخزينة",
                    "الأمين العام للمجموعة",
                ],
            },
            {
                title : "الأعضاء الإضافيون",
                subtitle : "المدعوون الدائمون للجنة هم:",
                list : [
                    "الرئيس التنفيذي للموارد البشرية",
                    "الرئيس التنفيذي للاستراتيجية",
                    "رئيس التواصل المؤسسي والممارسات البيئية والاجتماعية والحوكمة المؤسسية",
                ]
            }
        ],
        borderBoxTwo : {
            title : "منتدى التمويل المستدام لقطاع الخدمات المصرفية للشركات والمؤسسات ",
            subtitle : "تماشياً مع تطور سوق التمويل المستدام، يسعى الأول إلى توسيع نطاق منتجاته المالية المستدامة باستخدام كل من الهياكل القائمة على العوائد والحوافز (التمويل المرتبط بالاستدامة) بناءً على مبادئ السوق الموضحة أدناه، لتلبية الطلب المتزايد من العملاء. وضماناً للحوكمة السليمة لهذه العملية، قام البنك بإنشاء منتدى التمويل المستدام لقطاع الخدمات المصرفية للشركات والمؤسسات سعياً لتحقيق الأهداف التالية:"
        },
        listOne : [
            "توفير مستوى عالٍ من الحوكمة والإشراف على عروض التمويل المستدام المقدمة من قطاع الخدمات المصرفية للشركات والمؤسسات من أجل ضمان اتساق النهج على مستوى القطاع",
            "تقديم المصادقة لوحدات العمل بشأن تصنيف معاملات التمويل المستدام",
            "متابعة المستجدات الخاصة بالتتبع الداخلي لنشاط القروض الخضراء أو الاجتماعية أو المستدامة لإعداد التقارير المتعلقة بها"
        ],
        paragraphTwo : "يقوم رئيس منتدى التمويل المستدام لقطاع الخدمات المصرفية للشركات والمؤسسات بالإبلاغ عن الأمور التي تحتاج إلى تصعيد، إلى لجنة الإدارية للخدمات المصرفية للشركات والمؤسسات أو اللجنة التوجيهية للممارسات البيئية والاجتماعية والحوكمة المؤسسية عند اللزوم. ويقوم المنتدى بمراجعة معاملات العملاء بما في ذلك تمويل الشركات والتمويل التجاري، وفقاً لمبادئ السوق المتعارف عليها والمعتمدة (من قبل جمعية سوق القروض، ورابطة سوق قروض آسيا والمحيط الهادئ، ومنظمة جمعيات القروض والتجارة)، ومنها ما يلي:",
        cardsTwo : [
            {
                title : "مبادئ القروض الخضراء",
                subtitle : "يشترط العملاء الالتزام بـ 4 ركائز ضمن هذا المبدأ، والركيزة الأساسية هي إتاحة القروض لتمويل /وإعادة تمويل المشاريع الخضراء المؤهلة الجديدة أو القائمة كلياً أو جزئياً والتي يمكن أن تشمل على سبيل المثال لا الحصر الطاقة المتجددة والمباني الخضراء والنقل النظيف ومكافحة التلوث وغيرها من الفئات الأخرى.",
            },
            {
                title : "مبادئ القروض الاجتماعية",
                subtitle : "تحدد هذه المبادئ إطاراً يمكّن العملاء من تقييم نتائج مشاريعهم ضمن المعايير المحددة. وتشمل معايير المشاريع الاجتماعية على سبيل المثال لا الحصر تأثير المشروع على الأشخاص ذوي الإعاقة والمجتمعات المهمشة والمهاجرين أو النازحين والعاطلين والنساء وغيرها من الفئات الأخرى.",
            },
            {
                title : "مبادئ القروض المرتبطة بالاستدامة",
                subtitle : " تسمح هذه المبادئ للعملاء بإنشاء تسهيلات اقتراض تحفزهم على تحقيق أهداف أداء مستدامة طموحة ومحددة مسبقاً. نظراً لأن هذه القروض تركز على العملاء الذين يتطلعون إلى الانتقال إلى نتائج مستقبلية إيجابية، فهناك معايير صارمة بشأن الفئة التي يمكن تحديد مؤشرات الأداء الرئيسية وفقاً لها، والتي تشمل على سبيل المثال لا الحصر تحسين كفاءة الطاقة وخفض انبعاثات غازات الدفيئة والطاقة المتجددة وحقوق الإنسان، وأمن البيانات ،وأخلاقيات العمل وغيرها."
            }
        ],
        paragraphThree : "ويجتمع منتدى التمويل المستدام لقطاع الخدمات المصرفية للشركات والمؤسسات عند اللزوم لمراجعة معاملات التمويل المستدام في ضوء مبادئ السوق المحددة."
    },
    flexViewSection : [
        {
            image : {
                name : "img-2.jpg",
                alt : "Light Cross the trees",
            },
            title : "Social Impact",
            subtitle : "Play a leading role to shape an inclusive and diverse society, positively impacting our stakeholders",
            button : {
                text : "Read More",
                path : pagesNames.home
            }
        },
        {
            image : {
                name : "img-5.jpg",
                alt : "a person using a laptop",
            },
            title : "Overarching Goal",
            subtitle : "Commitment towards a high standard of governance, driving integrity and responsibility in all decision-making.",
            button : {
                text : "Read More",
                path : pagesNames.home
            }
        },
        {
            image : {
                name : "img-4.jpg",
                alt : "A woman helps a child",
            },
            title : "Sustainability in Our Operations",
            subtitle : "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim",
            button : {
                text : "Read More",
                path : pagesNames.home
            }
        },
    ]
};

export default governancePageData;